// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"243":"d74732b6","453":"75c88b10","992":"8eb1902d"}[chunkId] + ".chunk.js";
};